import {ErrorWrapper, ResponseWrapper} from '@/core/service/util'
import {RoomBaseApiService} from '@/core/service/room.baseapi.service'

class RoomSettingService extends RoomBaseApiService {
    constructor() { super() }

    async changeCameraRole(cameraOn) {
        if(typeof cameraOn !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeCameraRole`, { cameraOn })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeMicRole(micOn) {
        if(typeof micOn !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeMicRole`, { micOn })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeResetRole(reset) {
        if(typeof reset !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeResetRole`, { reset })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeDefaultRoleId(defaultRoleId) {
        if(!defaultRoleId) return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeDefaultRoleId`, { defaultRoleId })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeDefaultDevice(defaultDevice) {
        if(!defaultDevice) return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeDefaultDevice`, { defaultDevice })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeChatMode(chatMode) {
        if(typeof chatMode !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeChatMode`, { chatMode })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeWaitingMode(waitingMode) {
        if(typeof waitingMode !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeWaitingMode`, { waitingMode })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeDeviceRequired(isDeviceRequired) {
        if(typeof isDeviceRequired !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeDeviceRequired`, { isDeviceRequired })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeTranslateMode(translateMode) {
        if(typeof translateMode !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeTranslateMode`, { translateMode })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeStickerMode(stickerMode) {
        if(typeof stickerMode !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeStickerMode`, { stickerMode })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeDocMargin(docMargin) {
        if(typeof docMargin !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeDocMargin`, { docMargin })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeQuality(quality) {
        if(!quality) return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeQuality`, { quality })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeUseQnA(useQnA) {
        if(typeof useQnA !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeUseQnA`, { useQnA })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeUseQnAShare(useQnAShare) {
        if(typeof useQnAShare !== 'boolean') return;
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/setting/changeUseQnAShare`, { useQnAShare })
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async changeWebinarType(webinarType) {
        try {
            const response = await this.request().post(
                `/api/v3/room/${this.getRoomId()}/changeWebinarType`,
                { webinarType }
            )
            return new ResponseWrapper(response, response.data.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const roomSettingService = new RoomSettingService()